function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { AutoGravity } from "../../qualifiers/gravity/autoGravity/AutoGravity.js";
import { FocusOnGravity } from "../../qualifiers/gravity/focusOnGravity/FocusOnGravity.js";
import { autoGravity } from "../../qualifiers/gravity.js";
import { FocusOnValue } from "../../qualifiers/focusOn.js";
/**
 * true if gravity starts with 'auto' or 'auto:'
 * @param gravity
 */

function isIAutoGravityString(gravity) {
  return gravity && "".concat(gravity).split(':')[0] === 'auto';
}
/**
 * Validate that given val is an ICompassGravity
 * @param gravity
 */


function isCompassGravity(gravity) {
  //const gravityString = `${(typeof gravity === "string" ? gravity : gravity.qualifierValue)}`;
  var gravityValue = getGravityValue(gravity);
  return ['north', 'center', 'east', 'west', 'south', 'north_west', 'south_east', 'south_west', 'north_east'].includes(gravityValue);
}
/**
 * Get the value of given gravity
 * @param gravity
 */


function getGravityValue(gravity) {
  return "".concat(gravity).replace('g_', '');
}
/**
 * Creates a compassGravity model
 * @param gravity
 */


function createCompassGravityModel(gravity) {
  return {
    compass: getGravityValue(gravity),
    gravityType: 'direction'
  };
}
/**
 * Validate that given gravity is an instance of ocr gravity
 * @param gravity
 */


function isOcrGravity(gravity) {
  return getGravityValue(gravity) === 'ocr_text';
}
/**
 * Creates an ocr gravity model
 */


function createOcrGravityModel() {
  return {
    gravityType: 'ocr'
  };
}
/**
 * Validate that given gravity is an instance of AutoGravity
 * @param gravity
 */


function isAutoGravity(gravity) {
  return "".concat(gravity.qualifierValue).split(':')[0] === 'auto';
}
/**
 * Create an instance of IAutoGravityObjectModel
 * @param gravity
 */


function createIAutoFocusObject(gravity) {
  var gravityString = gravity.toString();
  var values = gravityString.split('_');
  var result = {
    object: values[0]
  };

  if (values.length > 1) {
    if (values[1] === 'avoid') {
      result.avoid = true;
    } else {
      result.weight = +values[1];
    }
  }

  return result;
}
/**
 * Creates an auto gravity model from given AutoGravity
 * @param gravity
 */


function createAutoGravityModel(gravity) {
  var values;
  var gravityQualifier = gravity === 'auto' ? new AutoGravity() : gravity;

  if ("".concat(gravity).startsWith('auto:')) {
    values = "".concat(gravity).split(':').filter(function (v) {
      return v !== 'auto';
    });
  } else {
    values = gravityQualifier.qualifierValue.values.filter(function (v) {
      return v !== 'auto';
    });
  }

  var autoFocus = values.map(createIAutoFocusObject);
  return {
    gravityType: 'auto',
    autoFocus: autoFocus
  };
}
/**
 * Create IFocusOnGravityModel from FocusOnGravity
 * @param gravity
 */


function createFocusOnGravityModel(gravity) {
  var hasAutoGravity = "".concat(gravity).split(':').includes('auto');
  var values = gravity.qualifierValue.values;
  var focusOnValues = hasAutoGravity ? values.slice(0, values.length - 1) : values;
  var result = {
    gravityType: 'object',
    focusOnObjects: focusOnValues.map(function (v) {
      return "".concat(v);
    })
  };

  if (hasAutoGravity) {
    var _autoGravity;

    // Remove the first 'auto' value by slicing it, because it's added by autoGravity()
    var autoFocusObjects = values[values.length - 1].values.slice(1);

    var autoGravityInstance = (_autoGravity = autoGravity()).autoFocus.apply(_autoGravity, _toConsumableArray(autoFocusObjects));

    result.fallbackGravity = createAutoGravityModel(autoGravityInstance);
  }

  return result;
}
/**
 * Creates a FocusOnGravity from given string
 * @param gravity
 */


function createFocusOnGravity(gravity) {
  var values = gravity.split(':');
  var focusOnValues = values.map(function (g) {
    return new FocusOnValue(g);
  });
  return new FocusOnGravity(focusOnValues);
}
/**
 * Create a model of given gravity
 * @param gravity
 */


export function createGravityModel(gravity) {
  if (isCompassGravity(gravity)) {
    return createCompassGravityModel(gravity);
  }

  if (isOcrGravity(gravity)) {
    return createOcrGravityModel();
  }

  if (isIAutoGravityString(gravity) || isAutoGravity(gravity)) {
    return createAutoGravityModel(gravity);
  }

  return createFocusOnGravityModel(typeof gravity === 'string' ? createFocusOnGravity(gravity) : gravity);
}